export default __webpack_public_path__ + "static/media/thankyoukeyvis_tickets_dt.cdaa2295.png";